export default {
    namespaced: true,
    state: () => ({
        search: '',
        period: 'Current',
        month: null,
        year: null,
        tableOptions:
        {
            page: 1,
            itemsPerPage : 15,
            sortBy : [ "controldate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_SEARCH (state, payload){
            state.search = payload;
        },
        SET_PERIOD (state, payload){
            state.period = payload;
        },
        SET_MONTH (state, payload){
            state.month = payload;
        },
        SET_YEAR (state, payload){
            state.year = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        }
    },
    getters: {
        getSearch: (state) => state.search,
        getPeriod: (state) => state.period,
        getMonth: (state) => state.month,
        getYear: (state) => state.year,
        getTableOptions: (state) => state.tableOptions,
    }
}